import { render, staticRenderFns } from "./PingkaDataLight.vue?vue&type=template&id=13474bb5&scoped=true"
import script from "./PingkaDataLight.vue?vue&type=script&lang=js"
export * from "./PingkaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13474bb5",
  null
  
)

export default component.exports